import React from "react";
import { Alert, Button } from "@mui/material";
import Select from "react-select";

export default function OrganizationSelect({ context, inputId = "scheduling-organization", value = context.organizationRef,
  onChange = context.setSelectedOrgId, disabled = false, options = context.orgOptions || [], description }) {
  return <div className="scheduling-organization-select">
    <label htmlFor={inputId}>Organization</label>
    <Select inputId={inputId} options={options} value={options.find(option => option.value === value) || null}
      isLoading={context.orgsLoading} isDisabled={disabled || context.orgsLoading || context.orgsError}
      isClearable={false} onChange={option => onChange(option.value)} placeholder="Select organization…"
      classNamePrefix="scheduling-org" menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 1600 }) }} />
    {description && <small className="schedule-help">{description}</small>}
    {context.orgsError && <Alert severity="error" action={<Button onClick={context.refetchOrgs}>Retry</Button>}>Could not load organizations.</Alert>}
  </div>;
}
